<template>
  <div>
    <f7-link @click="showAlertViewer">
      <div class=" margin-top seleccionable">
        <span>
          <img
            v-if="primaryIcon"
            alt="iconLogo"
            src="@/static/icons/ic_notifications.svg"
          >

          <img
            v-else
            alt="iconLogo"
            src="@/static/img/ic_launcher.png"
            style="height: 33.3px; width: 33.3px;"
          >
        </span>

        <div>
          <span
            v-if="pendingReadingNum > 0"
            class="badge badge-indicadorAlertas"
          >
            {{ pendingReadingNum }}
          </span>
        </div>
      </div>
    </f7-link>

    <f7-popup
      v-model:opened="popupShowAlerts"
      class="popup-PCNotificationAlertERP"
    >
      <f7-navbar
        sliding
        class="at-navbar secondary-navbar"
        :title="t('common.alertsAndNotifications')"
      >
        <f7-nav-right>
          <f7-link
            popup-close
            icon="icon-close"
            @click="popupShowAlerts = false"
          />
        </f7-nav-right>
      </f7-navbar>

      <div>
        <f7-block class="content-button-notifications">
          <div v-if="!showPreload && lstAlert && lstAlert.length > 0">
            <f7-button
              fill
              color="greendark"
              @click="markAllAlertsRead"
            >
              {{ t('notificationAlerts.markAllAsRead') }}
            </f7-button>
          </div>
        </f7-block>

        <PCShowNoResults
          v-show="!showPreload && lstAlert.length === 0"
          :title="t('notificationAlerts.youHaveNoAlertsPendingReading')"
          :subtitle="t('notificationAlerts.noPendingAlertsYet')"
        />

        <UCPreload :show="showPreload" />

        <div
          v-if="lstAlert && lstAlert.length > 0"
          class="div-lstAlert"
        >
          <f7-block class="div-lstAlertFinalizadosYPendientes">
            <div
              v-for="alert in lstAlert"
              :key="alert.Id"
              class="list media-list no-chevron"
              :class="{ leido: alert.Situacion !== 'Pendiente' }"
            >
              <ul class="list-notifications">
                <li>
                  <div
                    v-if="alert.Situacion === 'Pendiente'"
                    class="status-type pending"
                  >
                    <div>{{ t('common.pending') }}</div>
                  </div>
                  <div
                    v-else
                    class="status-type finished"
                  >
                    <div>{{ t('notificationAlerts.finished') }}</div>
                  </div>

                  <a
                    href="#"
                    class="item-link item-content"
                  >
                    <div
                      v-if="alert.Alerta"
                      class="item-inner"
                    >
                      <div
                        class="item-title-row"
                      >
                        <div
                          class="item-title"
                          @click="showAlertDetail(alert)"
                        >
                          {{ HiStringSupport.TextMaximumLength(alert.Alerta.Titulo, 40) }}
                        </div>

                        <div
                          v-if="alert.Situacion === 'Pendiente'"
                          class="item-after"
                          @click="markAlertAsView(alert)"
                        >
                          <img
                            src="@/static/icons/ic_check_01.svg"
                            class="img-imagenPrincipalTrabajador"
                          >
                        </div>
                        <div
                          v-else
                          class="item-after"
                        >
                          <img
                            src="@/static/icons/ic_check_02.svg"
                            class="img-imagenPrincipalTrabajador"
                          >
                        </div>
                      </div>

                      <div
                        class="item-subtitle"
                        @click="showAlertDetail(alert)"
                      >
                        {{ `${formatDate(alert.Alerta.FechaHora)} - ${formatTime(alert.Alerta.FechaHora)}` }}
                      </div>

                      <div
                        class="item-text"
                        @click="showAlertDetail(alert)"
                      >
                        {{ HiStringSupport.TextMaximumLength(alert.Alerta.Texto, 100) }}
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </f7-block>
        </div>
      </div>
    </f7-popup>

    <!-- Popup DETALLE ALERTA -->
    <f7-popup
      v-model:opened="popupShowDetailAlert"
      class="popup-detalle-alerta"
    >
      <f7-navbar
        sliding
        class="at-navbar secondary-navbar"
        :title="t('notificationAlerts.notificationDetail')"
      >
        <f7-nav-right>
          <f7-link
            popup-close
            icon="icon-close"
            @click="popupShowDetailAlert = false"
          />
        </f7-nav-right>
      </f7-navbar>

      <template v-if="selectedAlert?.Alerta">
        <f7-block class="content-button-notifications">
          <div v-if="selectedAlert.Situacion === 'Pendiente'">
            <f7-button
              fill
              color="greendark"
              @click="markAlertAsView(selectedAlert)"
            >
              {{ t('notificationAlerts.markAsRead') }}
            </f7-button>
          </div>
        </f7-block>

        <f7-block>
          <f7-card>
            <f7-card-content :padding="true">
              <div class="popup-detalle-alerta__title">
                {{ selectedAlert.Alerta.Titulo }}
              </div>

              <div class="popup-detalle-alerta__date">
                <span> {{ formatDate(selectedAlert.Alerta.FechaHora) }}  </span>
                <span> - </span>
                <span> {{ formatTime(selectedAlert.Alerta.FechaHora) }}</span>
              </div>

              <div class="popup-detalle-alerta__text">
                {{ selectedAlert.Alerta.Texto }}
              </div>
            </f7-card-content>
          </f7-card>
        </f7-block>
      </template>
    </f7-popup>
  </div>
</template>

<script setup>
// @ts-check
import { storeToRefs } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useSettingRef } from '@erpagroapp/settings';
import { HiDateTimeSupport, HiStringSupport } from '@/js/common/HIConversionSupport';
import UCPreload from '@/components/common/UCPreload.vue';
import { callChangeAlertStatus, callGetAlertsERP } from '@/js/services/APIErp';
import { HiNotification } from '@/js/common/HINotificationSupport';
import eventBus from '@/js/event-bus';
import PCShowNoResults from '@/components/common/PCShowNoResults.vue';
import { f7 } from 'framework7-vue';
import {
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from 'vue';
import { useI18n } from 'vue-i18n';

/** @import { Ref } from 'vue' */
/** @import {
 * AlertaNotificacion,
 * BusquedaAlertaNotificacion,
 * } from '@erpagroapp/types' */

const props = defineProps({
  primaryIcon: {
    type: Boolean,
    default: true,
  },
  filter: {
    type: String,
    default: 'default',
  },
});

const popupShowAlerts = ref(false);
const pendingReadingNum = ref(0);
/** @type {Ref<AlertaNotificacion[]>} */
const lstAlert = ref([]);
/** @type {Ref<AlertaNotificacion | null>} */
const selectedAlert = ref(null);
const showPreload = ref(false);
const popupShowDetailAlert = ref(false);
/** @type {Ref<ReturnType<typeof setInterval> | null>} */
const updateTimer = ref(null);

const automaticUpdateAlertERP = useSettingRef('Alertas.ActualizarAutomaticamente');
const automaticUpdateIntervalAlertERP = useSettingRef('Alertas.TiempoActualizacionAutomatica');
const activarAlertasYNotificaciones = useSettingRef('Alertas.ActivarConFiltro');

const { t } = useI18n();
const {
  loginNeeded,
} = storeToRefs(useAppConfigStore());
const {
  criteriosDeBusquedaParaAlertasNotificacionDelUsuario,
} = storeToRefs(useTraceabilityStore());

watch(activarAlertasYNotificaciones, (val) => {
  if (val) {
    getAlertsERP(); // Cuando está cargado todo actualizamos las alertas.
  } else {
    resetAlerts();
  }
});

onMounted(() => {
  enableEvents();
  startComponent();
});

onBeforeUnmount(() => {
  disableEvents();
  removeIntervalAutomaticUpdates();
});

function startComponent() {
  if (props.filter !== 'default' && !activarAlertasYNotificaciones.value) {
    return;
  }

  if (!automaticUpdateAlertERP.value) {
    return;
  }

  getAlertsERP();
  newUpdateTimer();
}

function enableEvents() {
  eventBus.on('push-notification-received', (data) => {
    pushNotificationReceived(/** @type {any} */ (data));
  });
  eventBus.on('open-notification-show-alert', () => {
    popupShowAlerts.value = true;
  });
  eventBus.on('PCVisorDeAlertasYNotificaciones_actualizarNumeroAlertas', () => {
    if (activarAlertasYNotificaciones.value) {
      getAlertsERP();
    }
  });
}

function disableEvents() {
  eventBus.off('push-notification-received');
  eventBus.off('open-notification-show-alert');
  eventBus.off('PCVisorDeAlertasYNotificaciones_actualizarNumeroAlertas');
}

function resetAlerts() {
  lstAlert.value = [];
  pendingReadingNum.value = 0;
}

async function getAlertsERP() {
  if (props.filter !== 'default' && !activarAlertasYNotificaciones.value) {
    return;
  }

  showPreload.value = true;
  lstAlert.value = [];

  /** @type {BusquedaAlertaNotificacion[]} */
  const fil = props.filter === 'default' ? [] : (criteriosDeBusquedaParaAlertasNotificacionDelUsuario.value ?? []);

  // No need to request alerts if there are no filters, because it will not return any alerts
  if (fil.length === 0) {
    showPreload.value = false;
    return;
  }

  try {
    const { data } = await callGetAlertsERP(fil);
    lstAlert.value = data;
    pendingReadingNum.value = data.length;
  } catch {
    HiNotification.Toast(t('notificationAlerts.errorQuerying'));
  }

  showPreload.value = false;
}

function showAlertViewer() {
  getAlertsERP();
  popupShowAlerts.value = true;
}

/**
 * @param {AlertaNotificacion} alert
 * @returns {Promise<void>}
 */
async function markAlertAsView(alert) {
  alert.Situacion = 'Leida';

  try {
    await callChangeAlertStatus([alert]);
    pendingReadingNum.value -= 1;
  } catch {
    updateAlert();
  }
}

async function markAllAlertsRead() {
  lstAlert.value.forEach((element) => {
    element.Situacion = 'Leida';
  });

  try {
    await callChangeAlertStatus(lstAlert.value);
    pendingReadingNum.value = 0;
  } catch {
    updateAlert();
  }
}

/**
 * @param {string} dateTime
 * @returns {string}
 */
function formatDate(dateTime) {
  return HiDateTimeSupport.FormatDateTime(dateTime, 'DD/MM');
}

/**
 * @param {string} dateTime
 * @returns {string}
 */
function formatTime(dateTime) {
  return HiDateTimeSupport.FormatDateTime(dateTime, 'HH:mm');
}

/**
 * @param {AlertaNotificacion} alert
 * @returns {void}
 */
function showAlertDetail(alert) {
  popupShowDetailAlert.value = true;
  selectedAlert.value = alert;
}

function updateAlert() {
  getAlertsERP();
}

function newUpdateTimer() {
  updateTimer.value = setInterval(() => {
    if (loginNeeded.value || !automaticUpdateAlertERP.value) {
      removeIntervalAutomaticUpdates();
      return;
    }

    if (popupShowAlerts.value) {
      // Con el componente esta en visualización no actualizamos
      return;
    }

    updateAlert();
  }, automaticUpdateIntervalAlertERP.value * 1000);
}

function removeIntervalAutomaticUpdates() {
  if (updateTimer.value) {
    clearInterval(updateTimer.value);
  }
}

/**
 * @param {Record<string, any>} datosNotificacion
 * @returns {void}
 */
function pushNotificationReceived(datosNotificacion) {
  // Generamos la ALERTA Visual de notificación Flotante
  const floatingNotificationCard = f7.notification.create({
    title: datosNotificacion.title,
    titleRightText: 'Ahora',
    text: datosNotificacion.message,
    closeOnClick: true,
    closeTimeout: 6000,
    on: {
      click() {
        pushNotificationReceivedClick(datosNotificacion);
      },
    },
  });
  floatingNotificationCard.open();
  getAlertsERP(); // Actualizamos el listado de alertas.
}

/**
 * @param {Record<string, any>} data
 * @returns {void}
 */
function pushNotificationReceivedClick(data) {
  selectedAlert.value = data.Alerta; // TODO (Revisar que se recibe)
  popupShowDetailAlert.value = true;
}
</script>

<style lang="scss">
.content-button-notifications {
  div {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .button {
      height: 45px;
      padding: 2px 25px 0;
      border-bottom: 3px solid green;
    }
  }
}

.list-notifications {
  li {
    margin: 0 0 10px;

    .item-content {
      padding-left: 20px;
      border-radius: 6px;
      z-index: 1;

      .item-inner {
        background: rgb(67 78 111 / 10%);
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
        padding-left: 10px;

        .item-text {
          font-size: 14px;
          line-height: 1.3;
          margin-top: 6px;
          max-width: 90%;
        }
      }

      .item-after {
        img {
          z-index: 2;
        }
      }
    }
  }

  &::before {
    height: 0 !important;
  }

  &::after {
    height: 0 !important;
  }
}

.status-type {
  position: absolute;
  text-align: center;
  font-size: 10px;
  font-weight: 500;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  text-transform: uppercase;
  color: #fff;
  background: var(--his-dark-blue);
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 20px;
  height: 100%;
  writing-mode: vertical-rl;

  &.finished {
    background-color: green;
    opacity: 0.7;
    filter: grayscale(1);
  }

  div {
    transform: rotate(180deg);
    width: 100%;
    display: flex;
    align-items: center;
    color: #fff;
  }
}

.icon-notifications {
  background-image: url("@/static/icons/ic_notifications.svg");
}

.col-indicadorEstado {
  padding-top: 5px;
  padding-right: 10px;
}

.div-registroAlerta {
  padding-top: 8px;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 5px;
  background: #fafbfc;
  border-bottom: 1px solid var(--his-disabled);
}

.div-alertaNotificacionDetalle {
  padding-top: 22px;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid var(--his-disabled);
}

.div-registroAlerta.leido {
  opacity: 0.5;
}

.div-lstAlertFinalizadosYPendientes {
  margin-bottom: 5px;
  max-height: 100%;
  overflow-y: auto;
  height: 80vh;
}

.col-btnsOpcionesAlerta {
  min-height: 90px;
  width: 20%;
  display: grid;
}

.div-fechaYHoraMovimiento {
  margin-left: -75px;
}

.div-fechaYHoraMovimientoDetalle {
  position: absolute;
  top: 95px;
  left: 12px;
}

.btn-markAlertAsView {
  margin-left: 27px;
  margin-top: -40px;
}

.btn-detalleAlerta {
  margin-left: -23px;
  margin-top: 18px;
}

.row-textoAlertaDetalle {
  padding-left: 16px;
  padding-right: 27px;
}

.tituloTextoAlertaDetalle {
  padding-left: 16px;
}

.popup-detalle-alerta {
  background: var(--his-tierra-white);

  .card {
    margin: 0;
    border-radius: 6px;
  }

  &__title {
    color: var(--his-teal-green);
    font-size: 18px;
    font-weight: 500;
  }

  &__date {
    font-size: var(--f7-list-item-subtitle-font-size);
    font-weight: var(--f7-list-item-subtitle-font-weight);
    color: var(--f7-list-item-subtitle-text-color);
    padding: 0 0 5px;
  }

  &__text {
    font-weight: 400;
    color: var(--f7-list-item-text-text-color);
  }
}

.col-cabeceraDetalleAlerta {
  min-height: 70px;
}

.div-btnLeerTodas {
  background-color: rgb(172 160 149 / 20%);
  border: 1px solid var(--his-kiwi-pulp);
  border-radius: 8px;
  width: 184px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  float: right;
  margin-right: 10px;
}

.div-btnLeerTodas span {
  color: var(--his-kiwi-pulp);
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.26px;
  line-height: 22px;
  text-align: left;
}

.row-cabeceraAlertasYNotificaciones {
  padding: 16px;
}

.row-cabeceraDetalleAlerta {
  max-height: 40px;
}

.div-textoDetalleAlerta {
  max-height: 100%;
  overflow-y: auto;
  height: 70vh;
}

.div-elementoAccesoNotificaciones {
  margin-left: 20px;
  margin-top: 6px;
}

.badge-indicadorAlertas {
  position: absolute;
  top: 6px;
  left: 60px;
  background: red;
  color: #fff;
  margin-left: -25px;
}

.inidicador-amarillo-8 {
  background-color: var(--his-mandarina);
  color: var(--his-mandarina);
  border-radius: 100%;
  width: 8px;
  height: 8px;
  margin: 5px;
  display: flex;
}

.inidicador-verde-8 {
  background-color: #4cd964;
  color: #4cd964;
  border-radius: 100%;
  width: 8px;
  height: 8px;
  margin: 5px;
  display: flex;
}

.selectable {
  cursor: pointer;
  text-decoration: none;
}

.btn-base-azulOscuro-28 {
  background-color: var(--his-steel-blue);
  box-shadow: 0 4px 8px 0 rgb(42 55 71 / 15%);
  border: 1px solid var(--his-steel-blue);
  border-radius: 17px;
  width: 28px;
  height: 28px;
  min-height: 28px;
  min-width: 28px;
  margin: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
</style>
